var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrophyAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6693 8.92188L13.8359 13.3385L10.0026 10.1719L6.16927 13.3385L7.33594 9.00521L3.83594 6.08854L8.33594 5.83854L10.0026 1.67188L11.6693 5.83854L16.1693 6.08854L12.6693 8.92188ZM11.6693 15.8385H10.8359V13.3385L10.0026 12.5052L9.16927 13.3385V15.8385H8.33594C7.41927 15.8385 6.66927 16.5885 6.66927 17.5052V18.3385H13.3359V17.5052C13.3359 17.0632 13.1603 16.6393 12.8478 16.3267C12.5352 16.0141 12.1113 15.8385 11.6693 15.8385Z",
    fill: "#7747FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3547 8.52544L12.1032 8.72899L12.1859 9.04176L12.9553 11.9547L10.321 9.77858L10.0026 9.51552L9.68416 9.77858L7.05973 11.9466L7.81875 9.12738L7.90198 8.81824L7.65603 8.61329L5.13152 6.50952L8.36367 6.32996L8.68183 6.31228L8.80018 6.01642L10.0026 3.01035L11.205 6.01642L11.3234 6.31228L11.6415 6.32996L14.8468 6.50803L12.3547 8.52544Z",
    fill: "#FBD3AF",
    stroke: "#642DFB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyAward);
export default __webpack_public_path__ + "static/media/trophy-award.3700ff9351cb91986c6c1ea71c999357.svg";
export { ForwardRef as ReactComponent };